module.exports = __webpack_public_path__ + "img/Coke Light Bottle Coca Cola.5bab92ed.png";